import instance from '../axios';
export const getVoucherList = async (search, statusFilter) => {
    let params = [];
    if (search) params.push(`search=${search}`);
    if (statusFilter) params.push(`status=${statusFilter}`);
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';

    const response = await instance.get(`vouchers${queryString}`)
    return response?.data;
}